import { Outlet } from "react-router-dom";
import { AuthGuard } from "../auth/AuthGuard";
import { SiteLayout } from "../components/SiteLayout";

export default function CompetitionSite() {
  return (
    <AuthGuard>
      <SiteLayout>
        <Outlet />
      </SiteLayout>
    </AuthGuard>
  );
}
